import { DynamicFormV2Palette } from "@mui/material";

export type FormOverlayButtonComponentTokenType = {
  backgroundColor: string;
  labelColor: string;
  hoverBackgroundColor: string;
  border: string;
};

export const assignOverlayButtonComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark",
  isDull: boolean
) => {
  const isLightMode = mode === "light";

  const backgroundColor = isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy;

  return {
    backgroundColor,
    labelColor: formsPalette.text.intense,
    border: `1px solid ${isLightMode && isDull ? formsPalette.border.quiet : "transparent"}`,
    hoverBackgroundColor: isLightMode ? formsPalette.surface.hover.moderate : formsPalette.surface.hover.quiet,
  } as FormOverlayButtonComponentTokenType;
};
